export default __webpack_public_path__ + "static/media/PrintButton.24ab94a8.svg";